export const WHITELISTED_DEVICE_TOKEN = 'success';
export const IS_USER_WHITELISTED = 'IS_USER_WHITELISTED';
